import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import {
  Popover,
  Box,
  Typography,
  Button,
  Grid,
  Skeleton,
  IconButton
} from "@mui/material";
import restype from "../../assets/restype.png";
import {
  updateReservationType,
  updateSelectedDate,
} from "../../store/slice/Ticketing.slice";
import { useTheme } from "@emotion/react";
import dayjs from "dayjs";

const MultipleEventCalaenderView = ({
  Ref,
  isOpen,
  handleClose,
  isLoading,
  setOpenNext
}) => {
  const theme = useTheme();
  const [isImageValid, setIsImageValid] = useState(true); 
  const { EventorStdTicketData, reservType, EventDates } = useSelector(
    (store) => store?.Ticketing
  );
  const dispatch = useDispatch();

  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          width: { xs: "100%", sm: "100%", md: "550px" }, // Full width for xs and sm, fixed width for md and above
          p: 3,
          display: "flex",
          flexDirection: "column",
          // justifyContent: "",
          // alignItems: "center",
          gap: "1rem",
        }}
      >
        <Box sx={{display:"flex",justifyContent:"flex-start",alignItems:"flex-start",flexDirection:'column'}}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              textAlign:"left"
             
            }}
          >
            {`${reservType?.eventTicketName}`}
          </Typography>
          <Typography
          fontSize='14px'
          >
          {` ${reservType?.address} ${reservType?.eventLocation && '|'}
            ${reservType?.eventLocation}`}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",    
            }}
          >
           {reservType?.eventDateAndTime}
          </Typography>
        </Box>
        {EventDates?.map((item, i) => (
          <Box
            key={i}
            sx={{
              position:"relative",
              display: "flex",
              flexDirection: { xs: "row" }, // Responsive flexDirection
              gap: "0.5rem",
              backgroundColor:
                reservType?.eventTicketId === item?.eventTicketId
                  ? theme?.resType?.itemBgActive
                  : theme?.resType?.itemBgColor,
              border: `1px solid ${theme?.resType?.borderColor}`,
              p: 2,
              borderRadius: "8px",
              cursor: "pointer",
              color:
                reservType?.eventTicketId === item?.eventTicketId
                  ? theme?.resType?.textColorActive
                  : theme?.resType?.itemTextColor,
              width: "100%", // Adjust width for small screens
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
                backgroundColor: theme?.resType?.itemBgHover,
                color: theme?.resType?.textHover,
              },
            }}
            onClick={() => {
              dispatch(updateSelectedDate(item));
              setOpenNext(true)
              handleClose();

            }}
          >
            <Grid container>
              
              {reservType?.imagePath && isImageValid && <Grid item xs={12} sm={4} md={4}>
              <Box
  sx={{
    width: "100%",
    height: "100%",
    maxHeight: "250px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "12px",
    overflow: "hidden", // Ensures content stays within the rounded corners
    "&:hover img": {
      transform: "scale(1.05)", // Slight zoom effect on hover
      transition: "transform 0.3s ease-in-out",
    },
  }}
>
  <img
    src={`${reservType?.imagePath}`}
    alt="res-type-img"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover", // Ensures the image fills the space
      borderRadius: "12px", // Apply border-radius to image
      transition: "transform 0.3s ease-in-out",
    }}
    onLoad={() => {
      setIsImageValid(true); // Confirm valid image
    }}
    onError={(error) => {
      setIsImageValid(false); // Mark image as invalid
    }}
  />
</Box>
              </Grid>}
              <Grid item xs={12} sm={reservType?.imagePath && isImageValid ? 8 : 12} md={reservType?.imagePath && isImageValid ? 8 : 12}>
                <Box sx={{ p: 1, width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      {dayjs(item?.availableDate).format('DD-MM-YYYY')}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      {dayjs(item?.fromTime, "HH:mm:ss").format("HH:mm")} - {dayjs(item?.toTime, "HH:mm:ss").format("HH:mm")}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
           
                }}
              >
                <IconButton
                  size="small"
                  sx={{
                    borderRadius: "7px",
                    backgroundColor:
                      reservType?.eventTicketId === item?.eventTicketId
                        ? theme?.resType?.chooseBgActive
                        : theme?.resType?.chooseBg,
                    color:
                      reservType?.eventTicketId === item?.eventTicketId
                        ? theme?.resType?.chooseTextActive
                        : theme?.resType?.chooseText,
                    "&:hover": {
                      backgroundColor: theme?.resType?.chooseBgHover,
                      color: theme?.resType?.chooseTextHover,
                    },
                  }}
                  onClick={() => {
                    dispatch(updateSelectedDate(item));
                    setOpenNext(true)
                    handleClose();
      
                  }}
                >
                  <AddCircleTwoToneIcon />
                </IconButton>
              </Box>
          </Box>
        ))}
      </Box>
    </Popover>

  );
};

export default MultipleEventCalaenderView;
